var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusSimple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M336 368C353.625 368 368 353.625 368 336S353.625 304 336 304S304 318.375 304 336S318.375 368 336 368ZM112 368C129.625 368 144 353.625 144 336S129.625 304 112 304S80 318.375 80 336S94.375 368 112 368ZM448 80C448 35.25 348.75 0 224 0S0 35.25 0 80V416C0 433.625 14.375 448 32 448V480C32 497.625 46.375 512 64 512S96 497.625 96 480V448H352V480C352 497.625 366.375 512 384 512S416 497.625 416 480V448C433.625 448 448 433.625 448 416V80ZM400 400H48V272H400V400ZM400 224H48V160H400V224ZM400 112H48V85.375C62.125 71.625 124.75 48 224 48S385.875 71.625 400 85.375V112Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusSimple);
export default __webpack_public_path__ + "static/media/bus-simple.b55e736b8788e76d5bf1141c37530e5b.svg";
export { ForwardRef as ReactComponent };